import axios from 'axios';
import { urlAPI } from '../../configurations/constantes';
import {
    RESET_STATE,

    LISTAGEM_PEDIDO_LOADING,
    LISTAGEM_PEDIDO,
    LISTAGEM_PEDIDO_ERRO,

    DETALHAMENTO_PEDIDO_LOADING,
    DETALHAMENTO_PEDIDO,
    DETALHAMENTO_PEDIDO_ERRO
} from '../types/PedidoType';

export const resetarStatePedido = () => {
    return (dispatch) => {
        dispatch({
            type: RESET_STATE
        });
    }
};

export const obterListagemPedido = () => {
    return (dispatch) => {
        dispatch({
            type: LISTAGEM_PEDIDO_LOADING,
            payload: true
        });

        const ud = JSON.parse(localStorage.getItem('user_data'));

        axios.get(`${urlAPI}/cust/${ud.codigoEmpresa}/pedidos`)
            .then((response) => {
                dispatch({
                    type: LISTAGEM_PEDIDO,
                    payload: response.data
                });
            })
            .catch((error) => {
                dispatch({
                    type: LISTAGEM_PEDIDO_ERRO,
                    payload: error
                });
            });
    }
};

export const obterDetalhamentoPedido = (contrato, pedido, item, sequencia) => {
    return (dispatch) => {
        dispatch({
            type: DETALHAMENTO_PEDIDO_LOADING,
            payload: true
        });

        const ud = JSON.parse(localStorage.getItem('user_data'));

        axios.get(`${urlAPI}/cust/${ud.codigoEmpresa}/pedidos/c/${contrato}/p/${pedido}/i/${item}/s/${sequencia}`)
            .then((response) => {
                dispatch({
                    type: DETALHAMENTO_PEDIDO,
                    payload: response.data,
                });
            })
            .catch((error) => {
                dispatch({
                    type: DETALHAMENTO_PEDIDO_ERRO,
                    payload: error
                });
            });
    }
};